export function useNumericOnly(e: any) {
    const keyCode = !((e.keyCode !== 45 && e.keyCode !== 46 && e.keyCode !== 37 && e.keyCode !== 39 && e.keyCode !== 110 && e.keyCode !== 190) && e.keyCode > 31 && (e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105));

    if (!keyCode) {
        e.preventDefault();
    }
}